import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  prefixs: []
}

export const mutations = {
  SET_PREFIXS(state, prefixs) {
    state.prefixs = prefixs
  },
  ADD_PREFIX(state, prefix) {
    state.prefixs.push(prefix)
  },
  EDIT_PREFIX(state, prefix) {
    const index = state.prefixs.findIndex(
      el => el.company_prefix_uuid === prefix.company_prefix_uuid
    )
    if (index !== -1) {
      state.prefixs.splice(index, 1, prefix)
    }
  },
  DELETE_PREFIX(state, company_prefix_uuid) {
    const index = state.prefixs.findIndex(
      el => el.company_prefix_uuid === company_prefix_uuid
    )
    if (index !== -1) state.prefixs.splice(index, 1)
  }
}

export const actions = {
  fetchPrefixs({ commit }, payload) {
    return ApiService.fetchPrefixs(payload)
      .then(res => {
        const prefixs = res.data.data
        commit('SET_PREFIXS', prefixs)
      })
      .catch(error => {
        throw error
      })
  },
  addPrefix({ commit }, payload) {
    return ApiService.addPrefix(payload)
      .then(res => {
        const prefix = res.data
        commit('ADD_PREFIX', prefix)
      })
      .catch(error => {
        throw error
      })
  },
  editPrefix({ commit }, payload) {
    return ApiService.editPrefix(payload)
      .then(res => {
        const prefix = res.data
        commit('EDIT_PREFIX', prefix)
      })
      .catch(error => {
        throw error
      })
  },
  deletePrefix({ commit }, payload) {
    return ApiService.deletePrefix(payload)
      .then(() => {
        commit('DELETE_PREFIX', payload.company_prefix_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}
